import React, { useEffect, useState, useContext } from "react";
import Row from "../Row";
import Column from "../Column";
import jobContext from "src/context/jobContext";
import { useLocation } from "react-router-dom";


const Table13 = ({ masouliatMoghararatScore, setMasouliatMoghararatScore, reload }) => {

  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const jobId = params.get("id");
  const { setGreadingScore } = useContext(jobContext)


  useEffect(() => {
    const items = JSON.parse(localStorage?.data)?.[jobId]?.masouliatMoghararat;
    if (items) {
      const masouliat = items[Object.keys(items)[0]];
      const masouliatData = [
        { name: "سطح یک", score: 6, isSelected: masouliat.value == 0 },
        { name: "سطح دو", score: 12, isSelected: masouliat.value == 1 },
        { name: "سطح سه", score: 18, isSelected: masouliat.value == 2 },
        { name: "سطح چهار", score: 24, isSelected: masouliat.value == 3 },
        { name: "سطح پنج", score: 30, isSelected: masouliat.value == 4 },

      ]


      const selectedItem = masouliatData.find((i) => i.isSelected)?.score
      setMasouliatMoghararatScore(selectedItem)
      setGreadingScore((prev) => ({ ...prev, "masouliatMoghararat": selectedItem }))
    }
  }, [reload])



  return (
    <div>
      <Row type={1}>
        <Column >سطح یک</Column>
        <Column >سطح دو</Column>
        <Column >سطح سه</Column>
        <Column >سطح چهار</Column>
        <Column >سطح پنج</Column>
      </Row>
      <Row type={2}>
        <Column paddingY={30}>
          استفاده و بکارگیری
          دستورالعمل ها و رویه
          های ساده و یکنواخت ،
          اجرا و پیشنهاد در سطح
          درون سازمانی
        </Column>
        <Column paddingY={30}>
          ستفاده و بکارگیری
          دستوالعمل ها و رویه های
          نسبتاً متنوع، تهیه و تدوین
          در سطح درون سازمانی
        </Column>
        <Column paddingY={30}>
          تهیه و تنظیم ،
          توضیح و تبیین
          دستورالعمل های
          متنوع ، نسبتاٌ پیچیده،
          بازنگری و پیشنهاد
          در اصالح در سطح
          درون سازمانی
        </Column>
        <Column paddingY={30}>
          نظارت، بازنگری و
          اصالح دستورالعمل
          ها، و روی های
          متنوع، و پیچیده،
          پیشنهاد در سطح
          درون سازمانی و
          برون سازمانی
        </Column>
        <Column paddingY={30}>
          مسئولیت پیشنهاد ، ابالغ
          و تصویب مجموعه آیین
          نامه ها، دستورالعمل ها،
          و رویه ها و نظارت بر
          حسن اجرای آنها در
          سطوح ملی و بین المللی
        </Column>
      </Row>
      <Row>
        <Column isActive={masouliatMoghararatScore == 6}>6</Column>
        <Column isActive={masouliatMoghararatScore == 12}>12</Column>
        <Column isActive={masouliatMoghararatScore == 18}>18</Column>
        <Column isActive={masouliatMoghararatScore == 24}>24</Column>
        <Column isActive={masouliatMoghararatScore == 30}> 30</Column>
      </Row>
    </div>
  );
};

export default Table13;
